<template>
    <div>
        <h3 class="color_Azul family-01" v-if="(form.TipoTema == 'IMAGEN' && form.Titulo != '' && Tipo == 1)" >{{form.Titulo}}</h3> 
        <hr v-show="(form.TipoTema == 'IMAGEN' && form.Titulo !='' && Tipo == 1)" class="divider-02 hr-sm-left-0 bg-color">  
        <h5 v-show="(form.TipoTema == 'IMAGEN' && form.Subtitulo !='' && Tipo == 1)" class="color_Azul">{{form.Subtitulo}}</h5>
        <div :id="'slider03'+Numero+index" class="carousel slide mb-3 slide-full" data-ride="carousel" v-if="(form.TipoTema == 'IMAGEN')">
            <div class="carousel-inner">

                <ol class="carousel-indicators" v-if="Tipo == 1">
                    <li  v-for="(detalle,key1) in form.detContenidoTema" :key="key1" v-show="(detalle.Archivo !='')" :data-target="'#slider03'+Numero+index" :data-slide-to="key1"  :class="{ '': key1 == 0, '': key1 > 0 }"></li>
                </ol>

                <div :class="{ 'carousel-item active': key3 == 0, 'carousel-item': key3 > 0 }" v-for="(detalle,key3) in form.detContenidoTema" :key="key3" v-show="(detalle.Archivo !='')">
                    <img :src="RutaFile+detalle.Archivo" class="d-block w-100" alt="...">
                     <div v-if="Tipo == 2" class="text-conten-img">
                        <h5  v-show="(form.Titulo !='')" class="family-01 contenido-azul color_Blanco">{{form.Titulo}}</h5>
                        <h3 v-show="(form.Subtitulo !='')" class="family-01 contenido-dorado color_Blanco">{{form.Subtitulo}}</h3>
                    </div> 
                </div>
            </div>

            

            <a v-if="form.detContenidoTema.length > 1" class="carousel-control-prev" :href="'#slider03'+Numero+index" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a v-if="form.detContenidoTema.length > 1" class="carousel-control-next" :href="'#slider03'+Numero+index" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
    </div>
</template>
<script>
export default {
    props:['value','RutaFile','listIconos','Tipo','index'],
    data() {
        return {
            form:this.value,
            Numero:''
        }
    },methods: {
        Aleatorio(){
            this.Numero = Math.round(Math.random()*10);
        }
    },mounted() {
        this.Aleatorio();
    },
}
</script>